import axios from 'axios'
import router from '@/router'
import autoLogin from '../helpers/autologin'

axios.interceptors.request.use(function (config) {
  config.baseURL = `${process.env.VUE_APP_URL}`
  const token = localStorage.getItem('token')
  const firebaseToken = localStorage.getItem('firebase_id_token')

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  // Token de cliente (Firebase) para endpoints de cuenta/direcciones.
  // No usamos Authorization para no pisar el token técnico del API.
  if (firebaseToken) {
    config.headers['X-Firebase-Token'] = firebaseToken
  }
  config.headers.Accept = 'application/json'
  return config
}, function (error) {
  return Promise.reject(error)
})

function requestUrl (config) {
  if (!config) return ''
  const u = config.url != null ? String(config.url) : ''
  const b = config.baseURL != null ? String(config.baseURL) : ''
  return (b + u) || u
}

/** Perfil Firebase: 400/401 no implican fallo del token técnico `/token` del API. */
function isCustomerProfileRequest (config) {
  return requestUrl(config).includes('/api/customer/')
}

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  // Si la petición tiene el flag skipErrorRedirect, no redirigir automáticamente
  // Esto es útil para peticiones de refresco automático donde queremos manejar errores manualmente
  const skipRedirect = error.config && error.config.skipErrorRedirect
  const softCustomer = isCustomerProfileRequest(error.config)

  if (!error.response) {
    localStorage.removeItem('token')
    if (!skipRedirect) {
      router.push({ name: 'ErrorPage' })
    }
  } else if (error.response.status === 401) {
    if (softCustomer) {
      return Promise.reject(error)
    }
    localStorage.removeItem('token')
    if (!skipRedirect) {
      autoLogin(() => {
        router.go(0)
      })
    }
  } else if (error.response.status === 500 || error.response.status === 400) {
    if (softCustomer) {
      return Promise.reject(error)
    }
    localStorage.removeItem('token')
    if (!skipRedirect) {
      router.push({ name: 'ErrorPage' })
    }
  }
  return Promise.reject(error)
})

export default axios
